import { FirebaseService } from '../firebase.service';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { promise } from 'protractor';


@Injectable({
  providedIn: 'root'
})
export class DadosService {

  private path: string = 'dados';
  private urlExcluir = 'https://us-central1-grupo-cultural.cloudfunctions.net/excluirUsuario';
  private urlAlterarSenha = ' https://us-central1-grupo-cultural.cloudfunctions.net/updatePasswordUser';
  
  private urlBuscarBaseAntigaRetorno = 'https://us-central1-grupo-cultural.cloudfunctions.net/buscaDadosAlunoBaseAntigaRetornoNovo';
  private urlBuscarBaseAntigaRetornoVarios = 'https://us-central1-grupo-cultural.cloudfunctions.net/buscaDadosAlunoBaseAntigaRetornoNovoVarios';

  private urlCriarUser = 'https://us-central1-grupo-cultural.cloudfunctions.net/criarNovoUser';

  constructor(public firebaseService: FirebaseService, public http: Http) {
  }

  list() {
    return this.firebaseService.getList(this.path);
  }

  get(id) {
    return this.firebaseService.getObject(this.path,id);
  }

  add(doc) {
    return this.firebaseService.addItem(this.path, doc);
  }

  update(id, doc) {
    return this.firebaseService.updateItem(this.path,id, doc);
  }

  remove(id) {
    return this.firebaseService.removeItem(this.path, id);
  }

  getByField(campo, valor){
    return this.firebaseService.query(this.path, ref => ref.where(campo, '==', valor));
  }

  getByTripleFieldOrdener(campo1, valor1,campo2, valor2,campo3, valor3, order){
    return this.firebaseService.query(this.path, ref => ref.where(campo1, '==', valor1).where(campo2, '==', valor2).where(campo3, '==', valor3).orderBy(order, 'asc'));
  }

  getByDoubleFields(campo1, valor1, campo2, valor2){
    return this.firebaseService.query(this.path, ref => ref.where(campo1, '==', valor1).where(campo2, '==', valor2));
  }


  removeAuth(login) {

    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*')
    
    
    let temp = this.http.get(this.urlExcluir + login, { headers: headers }).subscribe(obj => {
      console.log("aqui");
      temp.unsubscribe();
    });

    
  }

  updateSenha(uid, senha) {
    console.log(uid, senha);
    
    var headers = new Headers();       
    headers.append('Access-Control-Allow-Origin', '*')
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
        
    let temp = this.http.post(this.urlAlterarSenha,{uid:uid, senha:senha}, { headers: headers }).subscribe(obj => {
      console.log(obj);
      temp.unsubscribe();
    });    
  }


  async buscarUsuarioBaseAntiga(usuario:string):Promise<any>{
    var headers = new Headers();       
    headers.append('Access-Control-Allow-Origin', '*')
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const temp = await this.http.post(this.urlBuscarBaseAntigaRetorno,{usuario:usuario}, { headers: headers }).toPromise();    
    return temp;
  }


  async buscarUsuarioBaseAntigaVarios(usuario:string):Promise<any>{
    var headers = new Headers();       
    headers.append('Access-Control-Allow-Origin', '*')
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const temp = await this.http.post(this.urlBuscarBaseAntigaRetornoVarios,{usuario:usuario}, { headers: headers }).toPromise();    
    return temp;
  }

  async criarUsuarioSemLogar(email:string, senha:string):Promise<any>{
    var headers = new Headers();       
    headers.append('Access-Control-Allow-Origin', '*')
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const temp = await this.http.post(this.urlCriarUser,{email:email, senha:senha}, { headers: headers }).toPromise();    
    return temp;
  }

}
